import _ from 'lodash';
import { createSelector } from 'reselect';

import {
  canShowExpandedVideoInfo,
  canShowExpandedVideoList,
} from '../../selectors/app-settings';
import { isFetching as isFetchingChannelVideos } from '../../selectors/channel-videos';
import { getVideoIds } from '../../redux/lazy-channel-videos/selectors';
import { getChannelForWidget } from '@wix/wix-vod-shared/common';

function isVideoInfoVisibleOnWindowSize({ width }) {
  return width > 1199;
}

function isVideoListVisibleOnWindowSize({ width, height }) {
  return width > 1023 && height > 499;
}

const isMoreThanOneVideoAtChannel = createSelector(
  getChannelForWidget,
  getVideoIds,
  isFetchingChannelVideos,
  (channel, videoIds, isFetching) => {
    if (_.isNumber(channel.videosCount)) {
      return channel.videosCount > 1;
    }

    return isFetching || _.size(videoIds) > 1;
  },
);

export const isInfoPanelVisible = createSelector(
  canShowExpandedVideoInfo,
  (state) => state.windowSize,
  (canShow, windowSize) =>
    canShow && isVideoInfoVisibleOnWindowSize(windowSize),
);

export const isVideoListVisible = createSelector(
  canShowExpandedVideoList,
  isMoreThanOneVideoAtChannel,
  (state) => state.windowSize,
  (canShow, isMoreThanOneVideo, windowSize) =>
    canShow && isMoreThanOneVideo && isVideoListVisibleOnWindowSize(windowSize),
);
